
export default {
    name: 'FilterDisplayMobile',
    props: {
        filterTitle: {
            type: String,
            required: true,
            default: '',
        },
        actualValue: {
            required: true,
            // default: () => {},
        },
        // filterOptions: {
        //     type: Array,
        //     required: true,
        //     default: () => [],
        // },

        mode: {
            type: String,
            required: false,
            default: 'default',
        },

        isMultiple: {
            type: Boolean,
            required: false,
            default: false,
        },
        defaultValue: {
            type: String,
            required: false,
        }
    },
    computed: {
        title() {
            if (this.mode.includes('deductible')) {
                if(this.mode.includes('money-plus')) {
                    return `${this.filterTitle} : ${this.actualValue.value[0].toLocaleString('en-US')} - ${this.actualValue.value[1].toLocaleString('en-US')} +`;
                }
                return `${this.filterTitle} : ${this.actualValue.value[0].toLocaleString('en-US')} - ${this.actualValue.value[1].toLocaleString('en-US')}`;
            }
            if (this.mode.includes('avg_premium')) {
                if(this.mode.includes('money-plus')) {
                    return `${this.filterTitle} : ${this.actualValue.value[0].toLocaleString('en-US')} - ${this.actualValue.value[1].toLocaleString('en-US')} +`;
                }
                return `${this.filterTitle} : ${this.actualValue.value[0].toLocaleString('en-US')} - ${this.actualValue.value[1].toLocaleString('en-US')}`;
            }
            if (this.mode.includes('gender')) {
                return this.actualValue.text;
            }
            if (this.mode.includes('smoker_status')) {
                return this.actualValue.text;
            }
            if (this.mode.includes('room_type')) {
                return this.actualValue.text;
            }
            if (this.mode.includes('medical_geographical_coverage')) {
                if (this.actualValue.length >= 1) {
                    return `${this.filterTitle} (${this.actualValue.length})`;
                }
                return `${this.filterTitle}`;
            }
            if (this.mode.includes('geographical_coverage')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }
            if (this.mode.includes('destination')) {
                if (this.actualValue.length >= 1) {
                    return `${this.filterTitle} (${this.actualValue.length})`;
                }
                return `${this.filterTitle}`;
            }
            if (this.mode.includes('insurer')) {
                if (this.actualValue.length >= 1) {
                    return `${this.filterTitle} (${this.actualValue.length})`;
                }
                return this.$t('products.insurer');
            }
            if (this.mode.includes('issue_age')) {
                return `${this.filterTitle} : ${this.actualValue
                ?.text}`;
            }
            if (this.mode.includes('annuity_start_age')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }

            if (this.mode.includes('property_age')) {
                return `${this.filterTitle} : ${this.actualValue}`;
            }
            if (this.mode.includes('termci_coverage')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }

            if (this.mode.includes('age')) {
                return `${this.filterTitle} : ${this.actualValue.value}`;
            }
            if (this.mode.includes('medical_plan')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }
            if (this.mode.includes('date')) {
                return `${this.actualValue[0]} - ${this.actualValue[1]}`;
            }

            if (this.mode.includes('feature')) {
                if (this.actualValue.length >= 1) {
                    return `${this.filterTitle} (${this.actualValue.length})`;
                }
                return this.filterTitle;
            }

            if (this.mode.includes('objective')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }

            if (this.mode.includes('payment_term')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }

            if (this.mode.includes('income_term')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }
            if (this.mode.includes('currency')) {
                return `${this.actualValue.text}`;
            }

            if (this.mode.includes('owner_type')) {
                return `${this.actualValue.text}`;
            }
            if (this.mode.includes('property_type')) {
                return `${this.actualValue.text}`;
            }

            if (this.mode.includes('property_gross_area')) {
                return `${this.filterTitle} : ${this.actualValue}`;
            }
            if (this.mode.includes('home_plan')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }
            if (this.mode.includes('income_term')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }
            if (this.mode.includes('total_premium')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }
            if (this.mode.includes('target_period')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }
            if (this.mode.includes('sum_assured_range')) {
                return `${this.filterTitle} : ${this.actualValue.value[0].toLocaleString('en-US')} - ${this.actualValue.value[1].toLocaleString('en-US')}`;
            }
            if (this.mode.includes('sum_assured')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }
            if (this.mode.includes('renewal_term')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }
            if (this.mode.includes('underwriting')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }
            if (this.mode.includes('multiple_claims')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }
            if (this.mode.includes('risk_preference')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }
            if (this.mode.includes('risk_level')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }
            if (this.mode.includes('distributor')) {
                if (this.actualValue.length >= 1) {
                    return `${this.filterTitle} (${this.actualValue.length})`;
                }
                return `${this.filterTitle}`;
            }
            if (this.mode.includes('first_year_premium')) {
                if(this.mode.includes('money-plus')) {
                    return `${this.filterTitle} : ${this.actualValue.value[0].toLocaleString('en-US')} - ${this.actualValue.value[1].toLocaleString('en-US')} +`;
                }
                return `${this.filterTitle} : ${this.actualValue.value[0].toLocaleString('en-US')} - ${this.actualValue.value[1].toLocaleString('en-US')}`;
            }

            if (this.mode.includes('custom-input')) {
                if(this.mode.includes('money-plus')) {
                    return `${this.filterTitle} : ${this.actualValue.value[0].toLocaleString('en-US')} - ${this.actualValue.value[1].toLocaleString('en-US')} +`;
                }
                return `${this.filterTitle} : ${this.actualValue.value[0].toLocaleString('en-US')} - ${this.actualValue.value[1].toLocaleString('en-US')}`;
            }

            if (this.mode.includes('tenlife_score')) {
                return `${this.filterTitle} : ${this.actualValue.text}`;
            }

            return this.actualValue?.text || this.filterTitle;
        }
    },
    methods: {
        handleClickFilter() {
            const type = this.mode.split(' ');
            this.$store.commit('modal/setDisplayMobileFilter', {isOpen: true, mode: type[0]})
        }
    }
}
